/*
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-04 11:23:22
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-04 14:10:49
 */
const TimeFormat = {
  timeToMonthDay (time) {
    const add0 = (i) => {
      return i < 10 ? '0' + i : i
    }
    const t = new Date(parseInt(time) * 1000)
    // var y = time.getFullYear()
    const m = t.getMonth() + 1
    const d = t.getDate()
    // var h = time.getHours()
    // var mm = time.getMinutes()
    // var s = time.getSeconds()
    return add0(m) + '.' + add0(d)
  },
  timeToMonthDayHour (time) {
    const add0 = (i) => {
      return i < 10 ? '0' + i : i
    }
    const t = new Date(parseInt(time) * 1000)
    // var y = time.getFullYear()
    const m = t.getMonth() + 1
    const d = t.getDate()
    const h = t.getHours()
    // var mm = time.getMinutes()
    // var s = time.getSeconds()
    return add0(m) + '.' + add0(d) + ' ' + add0(h)
  }
}
export default TimeFormat
